import React from 'react';
import './messages.css';

type MessageContentRenderProps = {
  fileContent: string
  needParseData?: boolean
}

export default function MessageContentRender({
  fileContent, needParseData = true,
}: MessageContentRenderProps) {
  const parsedContent = React.useMemo(() => {
    const fromBase64 = needParseData ? Buffer.from(fileContent, 'base64').toString() : fileContent;
    return xmlPrettier(fromBase64).split('\n');
  }, [fileContent, needParseData]);

  return (
    <div className="message-content-wrapper">
      {React.Children.toArray(parsedContent.map((row, index) => (
        <div className="message-content-row">
          <code>{index + 1}</code>
          <code dangerouslySetInnerHTML={{ __html: row }} style={{ whiteSpace: 'break-spaces' }} />
        </div>
      )))}
    </div>
  );
}

function xmlPrettier(sourceXml: string) {
  const xmlDoc = new DOMParser().parseFromString(sourceXml, 'application/xml');
  const errorNode = xmlDoc.querySelector('parsererror');
  if (errorNode) return sourceXml;
  const xmlStyle = [
    '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
    '  <xsl:strip-space elements="*"/>',
    '  <xsl:template match="para[content-style][not(text())]">',
    '    <xsl:value-of select="normalize-space(.)"/>',
    '  </xsl:template>',
    '  <xsl:template match="node()|@*">',
    '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
    '  </xsl:template>',
    '  <xsl:output indent="yes"/>',
    '</xsl:stylesheet>',
  ].join('\n');

  const xsltDoc = new DOMParser().parseFromString(xmlStyle, 'application/xml');
  const xsltProcessor = new XSLTProcessor();
  xsltProcessor.importStylesheet(xsltDoc);
  const resultDoc = xsltProcessor.transformToDocument(xmlDoc);
  const xmlText = new XMLSerializer().serializeToString(resultDoc);

  return parseXml(xmlText.split('\n'));
}

function parseXml(xml: string[]) {
  let newXml = '';
  xml.forEach((string) => {
    newXml += prepareString(string);
  });
  return newXml;
}

function prepareString(string: string) {
  let newString = '';
  let isOpen = false;
  let isStartParameter = false;
  let firstQuote = false;
  let prevChar = '';
  // eslint-disable-next-line no-restricted-syntax
  for (const char of string) {
    if (char === '<') {
      newString += '<b style="color: #5d80f5;">&lt;';
      isOpen = true;
      // eslint-disable-next-line no-continue
      continue;
    }

    if (isOpen && char === ' ') {
      newString += '</b> ';
      // eslint-disable-next-line no-continue
      continue;
    }

    if (isOpen && char === '=') {
      newString += `${char}<font color="#ee634a">`;
      isStartParameter = true;
      // eslint-disable-next-line no-continue
      continue;
    }

    if (isOpen && isStartParameter && char === '"') {
      if (!firstQuote) {
        firstQuote = true;
        newString += char;
      } else {
        newString += `${char}</font>`;
        firstQuote = false;
      }
      // eslint-disable-next-line no-continue
      continue;
    }

    if (char === '>') {
      if (prevChar === '/') {
        isOpen = false;
        newString = newString.substring(0, newString.length - 1);
        newString += '</font><b style="color: #5d80f5;">/&gt;</b>';
        // eslint-disable-next-line no-continue
        continue;
      }
      isOpen = false;
      newString += '</font><b style="color: #5d80f5;">&gt;</b>';
      // eslint-disable-next-line no-continue
      continue;
    }

    newString += char;
    prevChar = char;
  }
  return `${newString}\n`;
}
